'use strict';

const headingTokens = (theme) => ({
    // common
    headingTextColor: theme.colors.body.text,
    headingBackgroundColor: theme.colors.body.background,
    headingLetterSpacing: theme.typography.letterSpacing.m,
    headingFontFamily: theme.typography.fontFamily.regular,
    // heading 1
    heading1FontWeight: theme.typography.fontWeight.bold,
    heading1FontSize: theme.typography.fontSize.xxxl,
    heading1LineHeight: theme.typography.lineHeight.xxxl,
    // heading 2
    heading2FontWeight: theme.typography.fontWeight.bold,
    heading2FontSize: theme.typography.fontSize.xxl,
    heading2LineHeight: theme.typography.lineHeight.xxl,
    // heading 3
    heading3FontWeight: theme.typography.fontWeight.bold,
    heading3FontSize: theme.typography.fontSize.xl,
    heading3LineHeight: theme.typography.lineHeight.xl,
    // heading 4
    heading4FontWeight: theme.typography.fontWeight.bold,
    heading4FontSize: theme.typography.fontSize.l,
    heading4LineHeight: theme.typography.lineHeight.l,
    // heading 4 light
    heading4LightFontWeight: theme.typography.fontWeight.semibold,
    heading4LightFontSize: theme.typography.fontSize.l,
    heading4LightLineHeight: theme.typography.lineHeight.l,
    // heading 5
    heading5FontWeight: theme.typography.fontWeight.bold,
    heading5FontSize: theme.typography.fontSize.m,
    heading5LineHeight: theme.typography.lineHeight.s,
    // heading 5 light
    heading5LightFontWeight: theme.typography.fontWeight.semibold,
    heading5LightFontSize: theme.typography.fontSize.m,
    heading5LightLineHeight: theme.typography.lineHeight.s,
    // subtitle
    headingSubtitleFontWeight: theme.typography.fontWeight.semibold,
    headingSubtitleFontSize: theme.typography.fontSize.m,
    headingSubtitleLineHeight: theme.typography.lineHeight.m,
    // subtitle-light
    headingSubtitleLightFontWeight: theme.typography.fontWeight.normal,
    headingSubtitleLightFontSize: theme.typography.fontSize.m,
    headingSubtitleLightLineHeight: theme.typography.lineHeight.m,
});

exports.headingTokens = headingTokens;
//# sourceMappingURL=heading.js.map
